var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHealthFacilityHospitalGeneral = function SvgHealthFacilityHospitalGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002BFF",
    d: "M12.564 3.08H4.77C3.24 3.08 2 4.21 2 5.603v12.953c0 1.394 1.24 2.524 2.77 2.524h7.794c1.53 0 2.77-1.13 2.77-2.524V5.603c0-1.393-1.24-2.523-2.77-2.523"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.389 13.212v4.815h-1.83V7.182h1.83v4.477h4.552V7.182h1.823v10.845H10.94v-4.815z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002BFF",
    d: "M17.308 14.573h2.308a3.1 3.1 0 0 1 1.27.247c.371.162.662.4.872.716.21.315.315.694.315 1.138 0 .423-.096.79-.288 1.098a1.845 1.845 0 0 1-.81.707c-.348.162-.753.243-1.215.243h-1.336v2.358h-1.116zm2.425 3.271c.252 0 .476-.05.67-.153a1.13 1.13 0 0 0 .46-.436c.11-.19.166-.404.166-.644 0-.243-.057-.453-.17-.63a1.095 1.095 0 0 0-.473-.405 1.592 1.592 0 0 0-.684-.14h-1.287v2.408z"
  })));
};
export default SvgHealthFacilityHospitalGeneral;